import React, { Component } from "react"
import _ from "lodash"
import Measure from "react-measure"
import { Col } from "react-bootstrap"
import CoinFlip from "./coinFlip/view"

// Styles
import "./styles/questionImages.css"
import "../../../../src/styles/styles.css"

class QuestionImages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dimensions: {},
    }
  }

  /**
   * Render Winner Circle
   * @param {*} itemWidth
   * @param {*} itemHeight
   */
  renderWinnerCircle(itemWidth, itemHeight) {
    if (this.props.showResults) {
      return (
        <div
          className="winnerCircle center"
          style={{
            width: itemWidth > itemHeight ? itemHeight - 10 : itemWidth - 10,
            height: itemWidth > itemHeight ? itemHeight - 10 : itemWidth - 10,
          }}
        />
      )
    }
    return null
  }

  /**
   * Render Winner Tally
   * @param {boolean} isWinner
   * @param {object} result
   */
  renderWinnerTally(isWinner, result) {
    return (
      <div
        className="sheepPercentage center"
        style={{ backgroundColor: isWinner ? "#FFB479" : "#DADADA" }}
      >
        <h3 className="fontFamilyBold percentageText">
          {`${
            result ? parseFloat(Math.round(result.percent * 100) / 100) : 0
          }%`}
        </h3>
      </div>
    )
  }

  /**
   * Render Sheeps
   * @param {array} sheepsToDraw - answers
   */
  renderSheeps(sheepsToDraw) {
    const { height, width } = this.state.dimensions

    const { answers, answerStats, showResults } = this.props

    const itemWidth = width / 2 - 15
    let itemHeight = height / Math.ceil(answers.length / 2) - 40

    if (itemHeight > height / 2) {
      itemHeight /= 2
    }

    const orderedAnswers = _.orderBy(answerStats, "percent", "desc")

    let winnerAnswer
    let hasDraw = false

    if (orderedAnswers.length > 1) {
      winnerAnswer = orderedAnswers[0]
      hasDraw = winnerAnswer.percent === orderedAnswers[1].percent
    } else if (orderedAnswers.length === 1) {
      winnerAnswer = orderedAnswers[0]
    }

    return (
      <Measure
        onMeasure={(dimensions) => {
          this.setState({ dimensions: dimensions })
        }}
      >
        <Col xs={12} sm={12} className="sheepsContainer">
          {sheepsToDraw.map((sheep) => {
            const result = _.find(
              answerStats,
              (stat) => stat.answer_id === sheep.answer_id
            )
            const isWinner =
              !hasDraw &&
              winnerAnswer &&
              winnerAnswer.answer_id === sheep.answer_id

            return (
              <Col
                className="sheepImageContainer"
                key={sheep.answer_id}
                xs={6}
                style={{
                  height: itemHeight,
                  width: itemWidth,
                }}
              >
                {isWinner
                  ? this.renderWinnerCircle(itemWidth, itemHeight)
                  : null}
                <img
                  alt=""
                  className="sheepImage"
                  src={sheep.image}
                  style={{
                    width:
                      itemWidth > itemHeight ? itemHeight - 20 : itemWidth - 20,
                    height:
                      itemWidth > itemHeight ? itemHeight - 20 : itemWidth - 20,
                  }}
                />
                {showResults ? this.renderWinnerTally(isWinner, result) : null}
              </Col>
            )
          })}
        </Col>
      </Measure>
    )
  }

  /**
   * Render Coin Flip
   * @param {array} players
   */
  renderCoinFlip(players) {
    _.each(players, (userPlaying) => {
      const pl = _.find(
        this.props.players,
        (player) => player.user_id === userPlaying.user_id
      )
      userPlaying.baabaatar = (pl && pl.baabaatar) || {}
    })

    return <CoinFlip players={players} />
  }

  /**
   * Render the winner user
   * @param {object} user
   */
  renderPlayerWon(user) {
    const {players} = this.props

     const resultPlayer = _.find(
      players,
      (player) => player.user_id === user.user_id
    ) || user
    
    return resultPlayer ? (
      <Col xs={12} sm={12} className="winnerContainer p40">
        <h3 className="fontFamilyBold fontColorGray winnerLabel">
          AND THE WINNER IS...
        </h3>
        <img alt="" className="winnerBaabaatar" src={resultPlayer.baabaatar ? resultPlayer.baabaatar.render : ""} />
        <h3 className="fontFamilyBold fontColorBlack winnerLabel">
          {resultPlayer.username}
        </h3>
      </Col>
    ) : null
  }

  render() {
    const { answers, log, players } = this.props


    const { excluded_sheeps, users_playing } = (log && JSON.parse(log)) || {}

    // Filtering the sheeps to display based on the game log
    let sheepsToDraw = []
    if (excluded_sheeps) {
      sheepsToDraw = _.filter(answers, (answer) => {
        return excluded_sheeps.indexOf(answer.answer_id) === -1
      })
    } else {
      sheepsToDraw = answers
    }

    const usersPlaying = users_playing || []

    // If the game ended up with 2 final players the host should flip the coin
    if (usersPlaying.length === 2) {
      return this.renderCoinFlip(usersPlaying)
    }

    if (usersPlaying.length === 1) {
      return this.renderPlayerWon(usersPlaying[0])
    }

    return this.renderSheeps(sheepsToDraw)
  }
}

export default QuestionImages



// WEBPACK FOOTER //
// ./src/components/questionsWindow/questionImages/view.js